import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import client from "../../../../shared/api-client";
import logout from "../../../../shared/logout";
import * as validate from "../../../../shared/validate";
import { Link } from "react-router-dom";

class ForgetPasswordForm extends PureComponent {
  state = {
    email: "",
    error_message: "",
  };

  constructor(props) {
    super(props);
    this.showPassword = this.showPassword.bind(this);
  }

  componentDidMount() {
    logout();
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val });
  };

  onSubmit = () => {
    if (this.state.email.trim() === "") {
      this.setState({ error_message: "Please enter the email address." });
    } else if (validate.email(this.state.email.trim()) === false) {
      this.setState({ error_message: "Please enter the valid email address." });
    } else {
      this.forgetPassword();
    }
  };

  forgetPassword = () => {
    client(`admin/recover`, {
      method: "PUT",
      body: { email: this.state.email },
    }).then(
      (response) => {
        if (
          typeof response._user_message_type !== undefined &&
          response._user_message_type === "error"
        ) {
          this.setState({
            error_message: response._user_message,
            success_message: "",
          });

          // this.setState({
          //   error_message: "",
          //   success_message: error._user_message,
          // });
        } else {
          window.location.assign("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  render() {
    return (
      <div className="form">
        {this.state.error_message !== "" ? (
          <div className="errorMessage">{this.state.error_message}</div>
        ) : (
          ""
        )}

        {this.state.success_message !== "" ? (
          <div className="successMessage">{this.state.success_message}</div>
        ) : (
          ""
        )}

        <div className="form__form-group">
          <span className="form__form-group-label">Email</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="email"
              component="input"
              type="text"
              placeholder="Email"
              onKeyUp={this.formChangeHandler}
            />
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label colorWhite">
              <div className="account__forgot-password">
                <Link to="/">Login</Link>
              </div>
            </span>
          </div>
        </div>
        <div className="account__btns">
          <button
            className="btn btn-primary account__btn"
            onClick={this.onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}

// <Link className="btn btn-outline-primary account__btn" to="/register">Create
//   Account
// </Link>

export default reduxForm({
  form: "forget_password_form", // a unique identifier for this form
})(ForgetPasswordForm);
